import styled from "styled-components";
import Button from "./Button";
import { connect } from "react-redux";
import { useState } from "react";
import { resendVerificationEmail } from "api";
import { showAlert } from "utils/utils";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 48px;
  flex-wrap: nowrap;
  padding: 8px 24px;
  background-color: #e8f5ff;
  position: sticky;
  top: 72px;

  &[data-hidden="true"] {
    display: none;
  }

  @media screen and (max-width: 768px) {
    flex-flow: column;
    gap: 12px;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 24px;
  }
`;

const VerifyEmailPrompt = ({ user }) => {
  const [sending, setSending] = useState(false);

  const handleResend = async () => {
    setSending(true);
    try {
      const res = await resendVerificationEmail({ email: user.email });

      if (res?.data?.status === true) {
        showAlert({
          msg: res?.data?.message ?? "Verification email sent successfully",
          type: "success",
        });
      } else {
        showAlert({
          msg: res?.data?.message ?? "An error occurred",
          type: "danger",
        });
      }
      setSending(false);
    } catch (e) {
      showAlert({
        msg: e.message ?? "An error occurred",
        type: "danger",
      });
      setSending(false);
    }
  };

  return (
    <Wrapper data-hidden={user?.email_verified_at ? "true" : "false"}>
      <p className="l2 text">
        <strong>Verify your email to continue:</strong> An email has been sent
        to your inbox
      </p>
      <Button
        text="Re-send email"
        bg="var(--secondary)"
        onClick={handleResend}
        disabled={sending}
      />
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(VerifyEmailPrompt);
